export default __webpack_public_path__ + "static/media/users-not-selected.3bf3aacb.svg";